<template>
  <div class="my">
    <div class="top">
      <form action="/">
      <van-search
        v-model="flowForm.keyword"
        shape="round"
        background="#3f51b5"
        @search="changeItem"
        placeholder="搜索标题、申请人、编号、说明"
      />
      </form>
      <van-dropdown-menu active-color="#1989fa">
        <van-dropdown-item v-model="flowForm.status" :options="status" @change='changeItem'/>
        <van-dropdown-item v-model="flowForm.is_pay" :options="is_pay" @change='changeItem'/>
      </van-dropdown-menu>

    </div>
    <div class="content">
      <van-row class="myapprover card" v-for="item in approval" :key="item.id">
        <van-col span="24" class="title"><router-link :to="'/'+item.catalog.path+'/'+item.id">{{item.title}}</router-link>
          <van-tag type="primary" v-if="item.status ==0">待审核</van-tag>
          <van-tag type="success" v-if="item.status ==1">已通过</van-tag>
          <van-tag type="danger" v-if="item.status ==2">已驳回</van-tag>
          <van-tag type="warning" v-if="item.status ==5">已撤销</van-tag>

          <van-tag type="primary" v-if="item.is_pay ==0" v-show="item.status==1">待付款</van-tag>
          <van-tag type="success" v-if="item.is_pay ==1" v-show="item.status==1">已付款</van-tag>
        </van-col>
        <van-col span="24">编号：{{item.no}}</van-col>
        <van-col span="24">申请人：{{item.name}}</van-col>
        <van-col span="24">金额：{{item.amount}}元</van-col>
        <van-col span="24">类型：{{item.catalog.title}}</van-col>
        <van-col span="24" v-if="item.status ==0" style="text-align:center;">
          <van-button type="primary" @click="press(item.id)" size="small">催办</van-button>
        </van-col>
        <van-col span="24" v-if="item.status == 2||item.status == 5" style="text-align:center;">
          <van-button type="danger" @click="del_flow(item.id)" size="small">删除</van-button>
        </van-col>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '15px 1px 0px 1px' }"/>
        
      </van-row>
      <van-row>
        <van-col span="24">
          <van-pagination 
          v-model="flowForm.current_page" 
          :total="flowForm.total" 
          :items-per-page="flowForm.per_page" 
          :page-count='flowForm.last_page' 
          @change = "changePage"     />
          
        </van-col>

      </van-row>

    </div>

    <Footer active="MyAFlow"></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      approval:{},
      active:0,
      current_page:'',
      flowForm:{
        keyword:'',
        status:'',
        is_pay:'',

        current_page:1,
        last_page:'',
        total:15,
        per_page:5,

      },
      status: [
        { text: '所有审批', value: '' },
        { text: '待审核', value: 0 },
        { text: '已通过', value: 1 },
        { text: '已驳回', value: 2 },
        { text: '已撤销', value: 5 },
      ],
      is_pay: [
        { text: '所有审批', value: '' },
        { text: '已付款', value: 1 },
        { text: '未付款', value: 0 },
      ],
    };
  },

  created() {
    // this.getCode();
    // console.log(this.$route.query)
    document.title = "我提交的申请";
    this.myflow();
  },
  methods: {
    myflow() {
      // this.flowForm.page = this.flowForm.current_page
      this.$http.post("my_flow",this.flowForm).then((res) => {
        console.log(res);
        if(res.data.code == 204){
          this.$router.push({'name':'Login'})
          return false;
        }
        this.approval = res.data.data.data;
        this.flowForm.current_page = res.data.data.current_page
        this.flowForm.total = res.data.data.total
        this.flowForm.per_page = res.data.data.per_page
        this.flowForm.last_page =res.data.data.last_page
        console.log(this.flowForm)
      });
    },
    changePage(){
      this.flowForm.page = this.flowForm.current_page
      this.myflow();
    },
    changeItem(){
      // localStorage.myflow_status = this.flowForm.status
      // localStorage.myflow_is_pay = this.flowForm.is_pay
      this.flowForm.page = 1;
      this.myflow();
    },
    //催办
    press(flow_id){
      this.$http.post('flow/press',{'flow_id':flow_id})
        .then((res)=>{
          console.log(res)
          if(res.data.code !=200){
            this.$dialog.alert({
              message: res.data.msg,
            })
            return false;
          }
          this.$dialog.alert({
            message: res.data.msg,
          })
          return false;
        })

    },
    //删除
    del_flow(flow_id){
      this.$dialog.confirm({
        message: '确定删除？',
      }).then((res)=>{
        this.$http.post('flow/delete',{'flow_id':flow_id})
        .then((res)=>{
          if(res.data.code !=200){
              this.$dialog.alert({
                message: res.data.msg,
              })
              return false;
            }
            this.$dialog.alert({
              message: res.data.msg,
            }).then((res)=>{
              this.myflow();
            })
        })

      })
      
    }
  },
};
</script>
<style scoped>
.home {
  background: url(/images/home_bg.jpg) repeat-x;
}
.payment {
  margin: 0px 10px 100px 10px;
  padding-top: 10px;
}
.demo_nav{
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    height: 56px;
    background-color: #fff;
}
.demo-nav__title {
    font-weight: 600;
    font-size: 17px;
    text-transform: capitalize;
}
.demo-nav__back {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 24px;
    height: 24px;
    cursor: pointer;
}
.van-cell__title{
  text-align:left;

}
.myapprover{
  text-align:left;
  margin:0px 10px;
  line-height:20px;
  padding:0px;
  font-size:12px;

}
.myapprover .title{
  
  font-size:14px;
  line-height:28px;

}
.my{
  margin-bottom:140px;
}
.van-tag{
  margin:0px 8px;
  padding:5px;
}
.van-dropdown-menu{
  margin-bottom:20px;
}
/* .card {
  margin:20px 5px;
  padding: 12px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 4px #cccccc;

} */
.top{
  position:fixed;
  top:0px;
  right:0px;
  width:100%;
  height:60px; 
  z-index:99; 
  
}
.content{
  margin-top:120px;
}
.content a{
  color:hsl(210, 98%, 49%);
  font-weight:600;

}
.content a:visited {
    color:#5c6bc0 !important;
}
</style>
